import apiPaths from '../api-paths';

export default {
  indexes() {
    return axios.get(`${ apiPaths.API }/api/tools/indexes`);
  },
  reindex(name) {
    return axios.post(`${ apiPaths.API }/api/tools/indexes/${ name }/reindex`);
  },
};
